import type { QuestionDTO, QuestionnaireDTO } from './dto-client'
import { RenderingType } from './dto-client'

export interface Questionnaire {
    id: number
    title: string
    description: string
    questions: QuestionDTO[]
    additionalQuestions?: QuestionDTO[]
    conditionalShowing?: boolean
}

/**
 * Maps the QuestionnaireDTO wire shape to the normalized Questionnaire.
 * Sorts questions by order number and forces PEP_TYPE groups to render as
 * single choice. Replaces the former Questionnaire model class.
 */
export const toQuestionnaire = (data: QuestionnaireDTO): Questionnaire => ({
    id: data.id,
    title: data.title,
    description: data.description,
    additionalQuestions: data.additionalQuestions,
    questions: [...data.questions]
        .sort((a, b) => (a.orderNumber > b.orderNumber ? 1 : -1))
        .map((question) => {
            //HUN FIX for checkbox
            if (question.groupName === 'PEP_TYPE') {
                return {
                    ...question,
                    renderingType: RenderingType.SINGLE_CHOICE,
                }
            }

            return {
                ...question,
            }
        }),
    conditionalShowing: data.conditionalShowing,
})
